import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import {
  OptionItemSquare,
  OptionItemSquareList,
} from '@/pages/Onboarding/components/OptionItemSquare';
import { useOnboarding } from '@/pages/Onboarding/context';
import { BREAST_SIZE_OPTIONS } from '@/pages/Onboarding/options/BreastSize/BREAST_SIZE_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  OwnAiTitle,
  OwnAiTitleHighlight,
} from '../../../OwnAI/components/Title';
import { LayoutDataType } from '../../types';

import { PageStyles } from './BreastSize.styles';

export const ScreenBreastSize: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'BreastSize',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const breast_size = form.watch('breast_size');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['breast_size']>,
  ) => {
    form.setValue('breast_size', option.id);
    userService.createOrUpdate({
      onboarding_data: {
        breast_size: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  const handleBackStep = (): void => {
    wizard.nextStep();
  };

  return (
    <PageStyles>
      <OnboardingNavigation onBack={handleBackStep} />
      <IonContent>
        <OwnAiTitle>
          Choose her <OwnAiTitleHighlight>breast size</OwnAiTitleHighlight>
        </OwnAiTitle>
        <OptionItemSquareList>
          {BREAST_SIZE_OPTIONS.map((option) => (
            <OptionItemSquare
              key={option.id}
              isSelected={breast_size === option.id}
              onClick={() => handleSelect(option)}
              bgSrc={`${S3_BUCKET_URL}/layout-own-ai-ons/breast-size/${option.id}.jpg`}
              title={option.title}
              TEST_ID={`breast_size-${option.id}`}
            />
          ))}
        </OptionItemSquareList>
      </IonContent>
    </PageStyles>
  );
};
